/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Reformulation_TitleInputs */

const en_keyword_optimizer_reformulation_title = /** @type {(inputs: Keyword_Optimizer_Reformulation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggested Rewording`)
};

const de_keyword_optimizer_reformulation_title = /** @type {(inputs: Keyword_Optimizer_Reformulation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorgeschlagene Umformulierung`)
};

const fr_keyword_optimizer_reformulation_title = /** @type {(inputs: Keyword_Optimizer_Reformulation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reformulation suggérée`)
};

const es_keyword_optimizer_reformulation_title = /** @type {(inputs: Keyword_Optimizer_Reformulation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reformulación sugerida`)
};

const it_keyword_optimizer_reformulation_title = /** @type {(inputs: Keyword_Optimizer_Reformulation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riformulazione suggerita`)
};

const nl_keyword_optimizer_reformulation_title = /** @type {(inputs: Keyword_Optimizer_Reformulation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorgestelde herformulering`)
};

const pl_keyword_optimizer_reformulation_title = /** @type {(inputs: Keyword_Optimizer_Reformulation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerowane przeformułowanie`)
};

const fi_keyword_optimizer_reformulation_title = /** @type {(inputs: Keyword_Optimizer_Reformulation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehdotettu uudelleenmuotoilu`)
};

const da_keyword_optimizer_reformulation_title = /** @type {(inputs: Keyword_Optimizer_Reformulation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foreslået omformulering`)
};

const sv_keyword_optimizer_reformulation_title = /** @type {(inputs: Keyword_Optimizer_Reformulation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Föreslagen omformulering`)
};

/**
* | output |
* | --- |
* | "Suggested Rewording" |
*
* @param {Keyword_Optimizer_Reformulation_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_reformulation_title = /** @type {((inputs?: Keyword_Optimizer_Reformulation_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Reformulation_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_reformulation_title(inputs)
	if (locale === "fr") return fr_keyword_optimizer_reformulation_title(inputs)
	if (locale === "es") return es_keyword_optimizer_reformulation_title(inputs)
	if (locale === "it") return it_keyword_optimizer_reformulation_title(inputs)
	if (locale === "nl") return nl_keyword_optimizer_reformulation_title(inputs)
	if (locale === "pl") return pl_keyword_optimizer_reformulation_title(inputs)
	if (locale === "fi") return fi_keyword_optimizer_reformulation_title(inputs)
	if (locale === "da") return da_keyword_optimizer_reformulation_title(inputs)
	if (locale === "sv") return sv_keyword_optimizer_reformulation_title(inputs)
	return en_keyword_optimizer_reformulation_title(inputs)
});